import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./SettingsModal.module.css";

import { SettingsItem } from "../SettingsItem/SettingsItem";
import { useTranslation } from "react-i18next";

export const SettingsModal = ({ isOpen, onCancel, onSave }) => {
  const { t } = useTranslation();

  const [settings, setSettings] = useState([
    { title: "Bonus Legs", value: 3 },
    { title: "P.M. Legs", value: 1 },
    { title: "Function", value: 1 },
  ]);

  const handleChange = (index, direction) => {
    setSettings((prev) =>
      prev.map((s, i) =>
        i === index
          ? { ...s, value: direction === 1 ? s.value + 1 : s.value - 1 }
          : s
      )
    );
  };

  return (
    <>
      {isOpen && (
        <div className={styles.overlay}>
          <div className={styles.container}>
            <div className={styles.header}>
              {t("Eagle Parameter Seach Settings")}
            </div>
            <div className={styles.options}>
              {settings.map((setting, index) => {
                return (
                  <SettingsItem
                    key={setting.title}
                    header={setting.title}
                    max={8}
                    value={setting.value}
                    onChange={(direction) => handleChange(index, direction)}
                  />
                );
              })}
            </div>
            <div className={styles.btns}>
              <button className={styles.cancel} onClick={() => onCancel()}>
                {t("Cancel")}
              </button>
              <button className={styles.save} onClick={() => onSave(settings)}>
                {t("Save")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

SettingsModal.propTypes = {};
